import {
  Component,
  ElementRef,
  Inject,
  PLATFORM_ID,
  Renderer2,
  AfterViewInit,
} from '@angular/core';
import { links } from '../../constants/footer';
import { RouterLink } from '@angular/router';
import { TypographyComponent } from '../../../shared/ui-component/typography/typography.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { isPlatformBrowser } from '@angular/common';
import { RoutePaths } from '../../constants/routes';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true, // अगर आप Angular v15+ standalone component use कर रहे हो
  imports: [RouterLink, TypographyComponent, SvgIconComponent],
})
export class FooterComponent implements AfterViewInit {
  protected readonly links = links;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const footer = this.el.nativeElement;

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                this.renderer.removeClass(document.body, 'sticky-btn');
              } else {
                this.renderer.addClass(document.body, 'sticky-btn');
              }
            });
          },
          {
            root: null,
            threshold: 0.1,
            rootMargin: '0px 0px 20px 0px',
          }
        );

        observer.observe(footer);
      }
    }
  }

  protected readonly RoutePaths = RoutePaths;
}
